import store from "@/state/store";

export default [

  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/index.vue"),
  },

  {
    path: "/login",
    name: "login",
    component: () => import("../views/auth/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/customer/test",
    name: "customertest",
    meta: { title: "Home" },
    component: () => import("../views/customer/test.vue"),
  },
  {
    path: "/customer/create/:id/:hash",
    name: "customercreate",
    meta: { title: "Home" },
    component: () => import("../views/customer/create.vue"),
  },

  {
    path: "/customer/bank/:id/:hash",
    name: "customerbank",
    meta: { title: "Home" },
    component: () => import("../views/customer/bank.vue"),
  },

  {
    path: "/customer/create/auth",
    name: "auth",
    meta: { title: "Home" },
    component: () => import("../views/customer/authpage.vue"),
  },

  {
    path: "/customer/create/auth/:id/:hash",
    name: "idhash",
    meta: { title: "Curlec" },
    component: () => import("../views/customer/authpage.vue"),
  },

  {
    path: "/user/role",
    name: "Roles",
    meta: { title: "Roles", authRequired: true },
    component: () => import("../views/user/role"),
  },
  {
    path: "/user/user",
    name: "UserRole",
    meta: { title: "Roles", authRequired: true },
    component: () => import("../views/user/user"),
  },
  {
    path: "/pages/starter",
    name: "starter",
    meta: { title: "Starter", authRequired: true },
    component: () => import("../views/pages/starter"),
  },

  {
    path: "/partner/finco",
    name: "finco",
    meta: { title: "Finco", authRequired: true },
    component: () => import("../views/partner/finco"),
  },

  {
    path: "/partner/channel",
    name: "channel-partner",
    meta: { title: "Channel Partner", authRequired: true },
    component: () => import("../views/partner/channel"),
  },

  {
    path: "/partner/branch",
    name: "branch",
    meta: { title: "Branch", authRequired: true },
    component: () => import("../views/partner/branch"),
  },

  {
    path: "/partner/branch-details/:id",
    name: "branchDetails",
    meta: { title: "Branch", authRequired: true },
    component: () => import("../views/partner/branch-details"),
  },

  {
    path: "/device/category",
    name: "category",
    meta: { title: "Category", authRequired: true },
    component: () => import("../views/device/category"),
  },

  {
    path: "/device/brand",
    name: "brand",
    meta: { title: "Brand", authRequired: true },
    component: () => import("../views/device/brand"),
  },

  {
    path: "/program",
    name: "program",
    meta: { title: "Program", authRequired: true },
    component: () => import("../views/program/program-list"),
  },

  {
    path: "/program/program-details/:id",
    name: "programDetails",
    meta: { title: "Program", authRequired: true },
    component: () => import("../views/program/program-details"),
  },

  {
    path: "/partner/branch-create",
    name: "branchCreate",
    meta: { title: "Branch", authRequired: true },
    component: () => import("../views/partner/branch-create"),
  },
  {
    path: "/partner/channel-create",
    name: "channelCreate",
    meta: { title: "channel", authRequired: true },
    component: () => import("../views/partner/channel-create"),
  },

  {
    path: "/device/product-list",
    name: "productList",
    meta: { title: "Product", authRequired: true },
    component: () => import("../views/device/product-list"),
  },

  {
    path: "/device/product-details/:id",
    name: "productDetails",
    meta: { title: "Product", authRequired: true },
    component: () => import("../views/device/product-details"),
  },

  {
    path: "/device/product-create",
    name: "product-create",
    meta: { title: "Product", authRequired: true },
    component: () => import("../views/device/product-details"),
  },

  {
    path: "/device/program-device",
    name: "programDevice",
    meta: { title: "Program Device", authRequired: true },
    component: () => import("../views/device/program-device"),
  },
  {
    path: "/device/product-create",
    name: "product-create",
    meta: { title: "Product", authRequired: true },
    component: () => import("../views/device/product-details"),
  },

  {
    path: "/device/program-device-details/:id",
    name: "programDeviceDetails",
    meta: { title: "Program Device", authRequired: true },
    component: () => import("../views/device/program-device-details"),
  },

  {
    path: "/device/create-program-device",
    name: "createProgramDevice",
    meta: { title: "Program Device", authRequired: true },
    component: () => import("../views/device/create-program-device"),
  },

  {
    path: "/customer/customer-list",
    name: "customerList",
    meta: { title: "Customers",authRequired: true},
    component: () => import("../views/customer/customer-list.vue"),
  },

  {
    path: "/customer/customer-details/:id",
    name: "customerDetails",
    meta: { title: "Customer Details",authRequired: true},
    component: () => import("../views/customer/customer-details.vue"),
  },

  {
    path: "/customer/customer-details/:id/ar",
    name: "customerDetailsArDetails",
    meta: { title: "Customer Details Ar",authRequired: true},
    component: () => import("../views/customer/customer-ar.vue"),
  },

  {
    path: "/customer/customer-details/:id/ar/invoice",
    name: "customerDetailsArInvoice",
    meta: { title: "Customer Details Ar (Invoice)",authRequired: true},
    component: () => import("../views/customer/customer-details-invoice.vue"),
  },

  {
    path: "/customer/customer-details/:id/ar/creditnote",
    name: "customerDetailsArCreditNote",
    meta: { title: "Customer Details Ar (Credot Note)",authRequired: true},
    component: () => import("../views/customer/customer-details-cn.vue"),
  },

  {
    path: "/customer/customer-details/:id/ar/soa",
    name: "customerDetailsArSoa",
    meta: { title: "Customer Details Ar (SOA)",authRequired: true},
    component: () => import("../views/customer/customer-details-soa.vue"),
  },

  {
    path: "/customer/customer-details/:id/ar/agingreport",
    name: "customerDetailsArAggingReport",
    meta: { title: "Customer Details Ar (Agging Report)",authRequired: true},
    component: () => import("../views/customer/customer-details-agingreport.vue"),
  },

  {
    path: "/customer/customer-details/:id/ar/payment",
    name: "customerDetailsArListPayment",
    meta: { title: "Customer Details Ar (List of Payment)",authRequired: true },
    component: () => import("../views/customer/customer-details-payment.vue"),
  },

  {
    path: "/customer/customer-details/:id/ar/nod",
    name: "customerDetailsArListPaymentNOD",
    meta: { title: "Customer Details Ar (NOD)",authRequired: true },
    component: () => import("../views/customer/nod.vue"),
  },

  {
    path: "/orders/order-list",
    name: "orderList",
    meta: { title: "Orders",authRequired: true},
    component: () => import("../views/orders/order-list.vue"),
  },

  {
    path: "/contracts/contract-list",
    name: "contractList",
    meta: { title: "Contracts",authRequired: true},
    component: () => import("../views/contracts/contract-list.vue"),
  },

  {
    path: '/auth/logout-basic',
    name: 'logout-basic',
    meta: {
      title: "Logout", authRequired: true,
    },
    component: () => import('../views/auth/logout/basic')
  },
  {
    path: '/auth/logout-cover',
    name: 'logout-cover',
    meta: {
      title: "Logout", authRequired: true,
    },
    component: () => import('../views/auth/logout/cover')
  },

  {
    path: "/orders/customer-order-details/:cid",
    name: "customerOrderDetails",
    meta: { title: "Customer Order",authRequired: true},
    component: () => import("../views/orders/customer-order-details.vue"),
  },

  {
    path: "/contracts/customer-contract-details/:cid",
    name: "customerContractDetails",
    meta: { title: "Customer Contracts",authRequired: true},
    component: () => import("../views/contracts/customer-contract-details.vue"),
  },

  {
    path: "/customer/customer-check-details/:cid",
    name: "customerCheckDetails",
    meta: { title: "Customer Checks",authRequired: true},
    component: () => import("../views/customer/customer-check-details.vue"),
  },

  {
    path: '/auth/change-password/:uid',
    name: 'change-password',
    meta: {
      title: "Change Password", authRequired: true,
    },
    component: () => import('../views/auth/change-password.vue')
  },

  {
    path: '/audit_log',
    name: 'AuditLog',
    meta: {
      title: "Audit Log", authRequired: true,
    },
    component: () => import('../views/audit/audit-log.vue')
  },
  {
    path: '/search/curlec',
    name: 'CurlecSearch',
    meta: {
      title: "Curlec Search", authRequired: true,
    },
    component: () => import('../views/orders/customer_curlec_search.vue')
  },

  {
    path: "/finance/customers-refund",
    name: "customersRefund",
    meta: {
      title: "Customers Refund", authRequired: true,

    },
    component: () => import("../views/finance/customers-refund.vue"),
  },

  {
    path: "/finance/collection-retry",
    name: "collectionRetry",
    meta: {
      title: "ReCollect Listing", authRequired: true,

    },
    component: () => import("../views/finance/collection-retry.vue"),
  },

  {
    path: "/finance/Recollect-Automation",
    name: "collectAutomation",
    meta: { 
      title: "ReCollect Automation listing", authRequired: true,
  
    },
    component: () => import("../views/finance/recollectAutomation.vue"),
  },
  {
    path: "/finance/recollect-automation/new-submission",
    name: "collectAutomationNewSubmission",
    meta: { 
      title: "New Submission", authRequired: true,
  
    },
    component: () => import("../views/finance/Recollect-Automation/New-Submission.vue"),
  },
  {
    path: "/finance/recollect-automation/:date",
    name: "dashboardByDate",
    meta: { 
      title: "Dashboard By Date", authRequired: true,
  
    },
    component: () => import("../views/finance/recollectAutomation.vue"),
  },
  {
    path: "/finance/collection-retry/:id",
    name: "collectionRetryDetail",
    meta: {
      title: "ReCollect Detail", authRequired: true,

    },
    component: () => import("../views/finance/collection-retry-detail.vue"),
  },

  {
    path: "/finance/instantpay-automation",
    name: "instantpayAutomation",
    meta: {
      title: "Instantpay Automation",
      authRequired: true,

    },
    component: () => import("../views/finance/instantpay-automation.vue"),
  },


  {
    path: "/user/ext-users",
    name: "ExternalUser",
    meta: { title: "ExternalUser", authRequired: true },
    component: () => import("../views/user/ext-users"),
  },

  {
    path: "/user/create-ext-users",
    name: "CreateExtUser",
    meta: { title: "CreateExternalUser", authRequired: true },
    component: () => import("../views/user/create-ext-users"),
  },

  {
    path: "/user/list",
    name: "userlist",
    meta: { title: "ExternalUser", authRequired: true },
    component: () => import("../views/user/ext-users"),
  },

  {
    path: "/user/myprofile",
    name: "ExternalUsermyprofile",
    meta: { title: "ExternalUser", authRequired: true },
    component: () => import("../views/user/ext-users"),
  },

  {
    path: "/customer/mandate/auth/:id/:hash",
    name: "idhash_aftermandate",
    meta: { title: "aftermandate" },
    component: () => import("../views/customer/mandate.vue"),
  },

  {
    path: "/payment/payment-history",
    name: "paymenthistory",
    meta: { title: "Payment History" },
    component: () => import("../views/payment/payment-history.vue"),
  },

  {
    path: "/customer/customer-blacklist-check",
    name: "checkCustomerBlacklist",
    meta: { title: "Customer Blacklist",authRequired: true},
    component: () => import("../views/customer/customer-blacklist-check.vue"),
  },
  {
    path: "/customer/customer-blacklist-check/:nric",
    name: "checkCustomerBlacklistSearch",
    meta: { title: "Customer Blacklist",authRequired: true },
    component: () => import("../views/customer/customer-blacklist-check.vue"),
  },
  {
    path: "/dashboard/85b2073a1a1c01f446f45803a6629204a8ddcf5ba3aa2e495d14b67d269ebe66",
    name: "dashboarda",
    meta: { title: "Dashboard" },
    component: () => import("../views/dashboard/stat.vue"),
  },
  {
    path: "/dashboard/search/:hash",
    name: "dashboardsearch",
    meta: { title: "Dashboard" },
    component: () => import("../views/dashboard/stat.vue"),
  },

  {
    path: "/finance/instantpay-automation",
    name: "instantpayAutomation",
    meta: {
      title: "Instantpay Automation",
      authRequired: true,

    },
    component: () => import("../views/finance/instantpay-automation.vue"),
  },

  //ar module
  {
    path: "/ar/invoices/invoice-listing",
    name: "invoiceListing",
    meta: { title: "Monthly Statement Listing",authRequired: true},
    component: () => import("../views/ar/invoices/invoice-listing.vue"),
  },

  {
    path: "/ar/invoices/create",
    name: "createInvoice",
    meta: { title: "Invoice Creation",authRequired: true},
    component: () => import("../views/ar/invoices/create-invoice.vue"),
  },

  {
    path: "/ar/invoices/invoice-creation/:id",
    name: "invoiceCreation",
    meta: { title: "Invoice Creation",authRequired: true},
    component: () => import("../views/ar/invoices/invoice-creation.vue"),
  },

  {
    path: "/ar/invoices/invoice-details/:id",
    name: "invoiceDetails",
    meta: { title: "Monthly Statement Details",authRequired: true},
    component: () => import("../views/ar/invoices/invoice-details.vue"),
  },

  {
    path: "/ar/credit_notes/credit-note-listing",
    name: "creditNoteListing",
    meta: { title: "Credit Note Listing",authRequired: true},
    component: () => import("../views/ar/credit_notes/credit-note-listing.vue"),
  },

  {
    path: "/ar/credit_notes/create",
    name: "creditNoteCreate",
    meta: { title: "Credit Note Create",authRequired: true},
    component: () => import("../views/ar/credit_notes/create.vue"),
  },

  {
    path: "/ar/credit_notes/create/:invoiceId",
    name: "creditNoteCreateInvoiceId",
    meta: { title: "Credit Note Create",authRequired: true},
    component: () => import("../views/ar/credit_notes/create.vue"),
  },
  {
    path: "/ar/refund/create",
    name: "refundCreateCustomer",
    meta: { title: "Create Refund", authRequired: true},
    component: () => import("../views/ar/refund/create.vue"),
  },
  {
    path: "/ar/refund/create/:customerId",
    name: "refundCreateCustomerId",
    meta: { title: "Create Refund", authRequired: true},
    component: () => import("../views/ar/refund/create.vue"),
  },
  {
    path: "/ar/refund/refund-list",
    name: "refundList",
    meta: { title: "Refund List", authRequired: true},
    component: () => import("../views/ar/refund/refund-list.vue"),
  },
  {
    path: "/ar/credit_notes/credit-note-creation/:id",
    name: "creditNoteCreation",
    meta: { title: "Credit Note Creation",authRequired: true},
    component: () => import("../views/ar/credit_notes/credit-note-creation.vue"),
  },

  {
    path: "/ar/credit_notes/credit-note-details/:id",
    name: "creditNoteDetails",
    meta: { title: "Credit Note Details",authRequired: true},
    component: () => import("../views/ar/credit_notes/credit-note-details.vue"),
  },

  {
    path: "/ar/reports/aging-report",
    name: "agingReport",
    meta: { title: "Aging Report",authRequired: true},
    component: () => import("../views/ar/reports/aging-report.vue"),
  },

  // AR Feature

  {
    path: "/ar/invoice/view/:id",
    name: "viewinvoice",
    meta: { title: "View Monthly Statement", authRequired: true },
    component: () => import("../views/dashboard-customer/view-invoice.vue"),
    props: true,
  },

  {
    path: "/ar/collection/details",
    name: "collectiondetail",
    meta: { title: "Collection Details", authRequired: true },
    component: () => import("../views/arreport/collection-details.vue"),
    props: true,
  },

  {
    path: "/ar/reports/aging-report-details/:aid",
    name: "agingReportDetails",
    meta: { title: "Aging Report Details",authRequired: true},
    component: () => import("../views/ar/reports/aging-report-details.vue"),
  },

  {
    path: "/ar/collection/listing",
    name: "collectionlisting",
    meta: { title: "Collection Listing", authRequired: true },
    component: () => import("../views/arreport/collection-listing.vue"),
    props: true,
  },
  {
    path: "/ar/collection/listing/:batchId",
    name: "collectionBatch",
    meta: { title: "Collection Batch", authRequired: true },
    component: () => import("../views/arreport/collection-batch.vue"),
    props: true,
  },
  {
    path: "/ar/collection/:cid",
    name: "collectionPerId",
    meta: { title: "Collection Details", authRequired: true },
    component: () => import("../views/arreport/collection-detail.vue"),
    props: true,
  },

  {
    path: "/ar/customer/master/listing",
    name: "customermasterlisting",
    meta: { title: "Customer Master Listing", authRequired: true },
    component: () => import("../views/dashboard-customer/customer-master-listing.vue"),
    props: true,
  },

  {
    path: "/ar/instantpay/list",
    name: "instantpay_list",
    meta: { title: "List Instant Pay",authRequired: true},
    // views/ar/instantpay
    component: () => import("../views/ar/instantpay/list.vue"),
  },

  {
    path: "/ar/instantpay/generate",
    name: "instantpay_create",
    meta: { title: "Create Instant Pay",authRequired: true},
    // views/ar/instantpay
    component: () => import("../views/ar/instantpay/create.vue"),
  },

  {
    path: "/ar/instantpay/:orderId",
    name: "instantpay_create_orderId",
    meta: { title: "Create Instant Pay",authRequired: true},
    // views/ar/instantpay
    component: () => import("../views/ar/instantpay/create.vue"),
  },
  {
    path: "/ar/invoice/view/statement-account/:customerId",
    name: "statementofaccount",
    meta: { title: "View Monthly Statement", authRequired: true },
    component: () => import("../views/dashboard-customer/statement-of-account.vue"),
    props: true,
  },

  {
    path: "/ar/reports/aging-report-customer/:cid",
    name: "agingReportCustomer",
    meta: { title: "Aging Report Details",authRequired: true},
    component: () => import("../views/ar/reports/aging-report-customer.vue"),
  },

  {
    path: "/tnc",
    name: "termsAndCondition",
    meta: { title: "T&C Management",authRequired: true},
    component: () => import("../views/t&c/t&c-list.vue"),
  },
];